"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("../../../http/app"));
var price_get = {
    namespaced: true,
    state: {
        data: null,
    },
    mutations: {
        setData: function (state, data) {
            state.data = data;
        }
    },
    actions: {
        getPrice: function (_a, pay_method) {
            var commit = _a.commit;
            commit('setData', null);
            return app_1.default.get("prices/" + pay_method)
                .then(function (response) { return response.data.data; })
                .then(function (data) { return commit('setData', data); });
        }
    }
};
exports.default = price_get;
